<template>
  <div class="machine-root relative overflow-hidden px-5 py-10 sm:px-8 sm:py-14">
    <div class="machine-texture" aria-hidden="true" />

    <div class="mx-auto flex w-full max-w-6xl flex-col gap-12 sm:gap-16">
      <slot name="hero" />
      <slot />
    </div>
  </div>
</template>
